import { Link } from "react-router-dom";
import { t } from "../i18n";

export function NotFoundPage(): React.JSX.Element {
  return (
    <div style={styles.container}>
      <h1 style={styles.code}>{t("not_found.title")}</h1>
      <p style={styles.text}>{t("not_found.text")}</p>
      <Link to="/" style={styles.link}>
        {t("not_found.back")}
      </Link>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
  },
  code: {
    fontSize: 48,
    fontWeight: 700,
    color: "var(--color-text-secondary)",
    marginBottom: 8,
  },
  text: {
    fontSize: 16,
    color: "var(--color-text-secondary)",
    marginBottom: 24,
  },
  link: {
    fontSize: 14,
    color: "var(--color-primary)",
    textDecoration: "underline",
  },
};
